import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import cx from 'classnames';
import React from 'react';
import { withItem } from '../behaviors/item';
var BaseMenuItem = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var active = _ref.active,
      children = _ref.children,
      className = _ref.className,
      disabled = _ref.disabled,
      _onClick = _ref.onClick,
      onMouseDown = _ref.onMouseDown,
      props = _objectWithoutPropertiesLoose(_ref, ["active", "children", "className", "disabled", "onClick", "onMouseDown"]);

  return (
    /*#__PURE__*/

    /* eslint-disable jsx-a11y/anchor-is-valid */
    React.createElement("a", _extends({}, props, {
      className: cx('dropdown-item', {
        active: active,
        disabled: disabled
      }, className),
      href: "#",
      onClick: function onClick(e) {
        e.preventDefault();
        !disabled && _onClick && _onClick(e);
      },
      onMouseDown: onMouseDown,
      ref: ref
    }), children)
    /* eslint-enable jsx-a11y/anchor-is-valid */

  );
});
export { BaseMenuItem };
export default withItem(BaseMenuItem);